import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import { SocialSharingOptions } from 'src/types/SocialSharingOptions';

import { Favourite } from 'src/components/search/_Favourite/_Favourite';
import { ShareButton } from 'src/components/search/_ShareButton/ShareButton';

import styles from './ShareContent.module.css';

type shareContentProps = {
	/** ShareButton Props */
	shareButtonText?: Field<string>;
	shareButtonToolTip: Field<string>;
	shareOptions: SocialSharingOptions;
	noShareOptions: Field<string>;
	shareTitle: string;
	shareUrl: string;
	/** FavouriteButton Props */
	itemId?: string;
	showText: boolean;
	favouriteButtonText: Field<string>;
	favouriteButtonToolTip?: Field<string>;
	unfavouriteText: Field<string>;
	// Optional Class Name
	flexEnd?: boolean;
	toolbarIconSize?: boolean;
};

export const ShareContent = (props: shareContentProps) => {
	return (
		<div className={`${styles.shareContent} ${props.flexEnd && styles.flexEnd} ${props.toolbarIconSize && styles.toolbarIconSize}`}>
			<ShareButton
				shareButtonText={props.shareButtonText}
				shareButtonToolTip={props.shareButtonToolTip}
				shareOptions={props.shareOptions}
				noShareOptions={props.noShareOptions}
				shareTitle={props.shareTitle}
				shareUrl={props.shareUrl}
				alignLeft
				toolbarIconSize={props.toolbarIconSize}
			/>

			{props.itemId && (
				<Favourite
					itemId={props.itemId}
					showText={props.showText}
					favouriteButtonText={props.favouriteButtonText}
					favouriteButtonToolTip={props.favouriteButtonToolTip}
					unfavouriteText={props.unfavouriteText}
					toolbarIconSize={props.toolbarIconSize}
				/>
			)}
		</div>
	);
};
